export const REINIT = 'REINIT';
export const CHANGE_LOCATION = 'CHANGE_LOCATION';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_COLUMNS = 'SET_COLUMNS';
export const SEARCH = 'SEARCH';
export const SET_TABLE_SETTINGS = 'SET_TABLE_SETTINGS';
export const APPLY_PRESET = 'APPLY_PRESET';
export const SEARCH_QUERY = 'searchQuery';
